<a class="black p-0" data-original-title="" title="" (click)="readOnlyRoute()">
  <i class="ft-eye font-small-3 mr-2"></i>
</a>